import { render } from "./SingleFarmAction.vue?vue&type=template&id=791e0175&scoped=true&ts=true"
import script from "./SingleFarmAction.vue?vue&type=script&lang=ts"
export * from "./SingleFarmAction.vue?vue&type=script&lang=ts"

import "./SingleFarmAction.vue?vue&type=style&index=0&id=791e0175&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791e0175"]])

export default __exports__